import { IApiError } from '@/@types/AxiosError';
import { AxiosError } from 'axios';
import { toast } from 'react-toastify';

import i18n from '@/config/i18n';

import { Toast } from '../components/Toast';

import { logoutUserExpiredSession } from './logoutUserExpiredSession';

export class HttpResponseErrorsInterceptors {
  private error: AxiosError<IApiError>;

  private URLS_ALLOWED_401 = ['/user/get-user-info', '/oauth/token'];

  constructor(error: AxiosError<IApiError>) {
    this.error = error;
  }

  disconnectUser() {
    console.log(this.error);
    if (
      this.error?.config?.url &&
      this.URLS_ALLOWED_401.includes(this.error.config.url)
    ) {
      return this;
    }

    if (this.error.status === 401) {
      toast.warn(
        ({ closeToast }) => (
          <Toast
            message={i18n.t('login/signIn:sessionExpired')}
            description={i18n.t('login/signIn:signInToContinue')}
            type="warning"
            handleClose={closeToast}
          />
        ),
        {
          toastId: 'session-expired',
        },
      );

      logoutUserExpiredSession();
    }

    return this;
  }

  build() {
    return this.error;
  }
}
